import { render, staticRenderFns } from "./VulnerableReportIconField.vue?vue&type=template&id=04ebe362&scoped=true"
import script from "./VulnerableReportIconField.vue?vue&type=script&lang=js"
export * from "./VulnerableReportIconField.vue?vue&type=script&lang=js"
import style0 from "./VulnerableReportIconField.vue?vue&type=style&index=0&id=04ebe362&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04ebe362",
  null
  
)

export default component.exports